import RegionalInsuranceList from "@components/Pricing/RegionalInsuranceList/RegionalInsuranceList";
import {FeatureFlag} from "@services/featureFlagConstants";
import {fetchFeatureFlags} from "@services/featureFlags";
import {useTranslation} from "ni18n";
import React from "react";
import Faq from "src/components/v5/Faq/Faq";
import useInsurancePricingConstants from "src/constants/InsurancePricingConstants";
import {fetchPricingData} from "src/utils/fetchPricingData";

import {CarbonPage} from "../CarbonPage";
import Layout from "../components/v5/Layout";
import {NavTheme} from "../components/v5/Nav/useNavState";
import Billing from "../components/v5/Pricing/Billing";
import Header from "../components/v5/Pricing/Header";
import TestimonialSlider from "../components/v5/TestimonialSlider";
import {actions} from "../store";
import {NextPageContextWithStore} from "../store/types";

const InsurancePricing: CarbonPage = () => {
  const i18n = useTranslation();
  const {faq} = useInsurancePricingConstants();

  return (
    <Layout
      pageTitle={i18n.t(
        "Insurance & Pricing | Accepting All Major Insurance Providers | Carbon Health",
      )}
      pageDescription={i18n.t(
        "Carbon Health aims to make health high-quality healthcare accessible to all. We accepts all major insurance providers including medicare, cash payments, FSA & HSA.",
      )}
      pageImage="insurance-pricing-05032022"
      navTheme={NavTheme.LIGHT}
    >
      <Header />
      <RegionalInsuranceList />
      <Faq className="maxw75-f" faq={faq} />
      <Billing />
      <TestimonialSlider />
    </Layout>
  );
};

InsurancePricing.getInitialProps = async ({req, store}: NextPageContextWithStore) => {
  const pricingData = await fetchPricingData();
  const {featureFlags} = store.getState();

  if (featureFlags.GROWTH_HRSA_FAQ_CHANGES_ENABLED === undefined) {
    await fetchFeatureFlags(
      {
        [FeatureFlag.GROWTH_HRSA_FAQ_CHANGES_ENABLED]: true,
      },
      {
        dispatch: store.dispatch,
        req,
      },
    );
  }

  store.dispatch(actions.setRegionPricing(pricingData));

  return {};
};

export default InsurancePricing;
